// Top-level /inbox route, used when Lightspeed promotes Inbox to its own page
// in the new navigation. It renders the same view as home/inbox by reusing
// RouteHomeInbox (which keeps the .RouteHomeInbox wrapper the Lightspeed height
// fix relies on).
export default [
  {
    path: '/inbox',
    component: () => import('../home/RouteHomeInbox'),
    meta: {
      noSpacing: true,
    },
  },
];
